<template>
  <CustomModal
    :show="showModal" @closeModal="$emit('close')">
    <template #modal-header>
      System Settings
    </template>
    <template #modal-body>
      <p>No settings found. Click <b-link @click="goToSettings()">here</b-link> to go to settings.</p>
    </template>
    <template #modal-footer>
       <div class="button-footer">
          <b-button
            class="btn-close ml-2"
            variant="outline-danger"
            @click="$emit('close')">
            Close
          </b-button> 
      </div>
    </template>
  </CustomModal>
</template>
<script>
import { CustomModal } from "../components";
export default {
  name: 'SettingModal',
  components: {
    CustomModal
  },
  props: {
    show: Boolean,
    isProcessing: Boolean
  },
  computed: {
    showModal: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        return newValue
      }
    }
  },
  methods: {
    goToSettings() {
      this.$router.push({ path: '/settings/company' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .button-footer {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
  }
</style>